// Suporte a vídeo de exercício via link do YouTube.
// A plataforma da academia pode salvar um link do YouTube em video_url_1;
// aqui o app detecta pelo padrão da URL e toca em <iframe> embed (in-app),
// sem depender de coluna nova no schema.

const YT_PATTERNS = [
  /(?:youtube\.com|youtube-nocookie\.com)\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)([\w-]{11})/,
  /youtu\.be\/([\w-]{11})/,
];

/** Extrai o ID do vídeo de qualquer formato de link do YouTube (watch, youtu.be, shorts, embed). */
export function parseYouTubeId(url) {
  if (!url || typeof url !== "string") return null;
  for (const re of YT_PATTERNS) {
    const m = url.match(re);
    if (m) return m[1];
  }
  return null;
}

export const isYouTubeUrl = (url) => parseYouTubeId(url) !== null;

/** Embed que toca dentro do app (autoplay + playsinline, sem vídeos relacionados de outros canais). */
export const youTubeEmbedUrl = (id, { autoplay = true } = {}) =>
  `https://www.youtube-nocookie.com/embed/${id}?rel=0&playsinline=1${autoplay ? "&autoplay=1" : ""}`;

export const youTubeThumbUrl = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
